/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { BusinessTypeEbsIntegrationResponse } from '../models/business-type-ebs-integration-response';
import { CreateBusinessTypeEbsIntegrationRequest } from '../models/create-business-type-ebs-integration-request';
import { GenericResponse } from '../models/generic-response';
import { GetBusinessTypeEbsIntegrationResponse } from '../models/get-business-type-ebs-integration-response';
import { UpdateBusinessTypeEbsIntegrationRequest } from '../models/update-business-type-ebs-integration-request';

/**
 * Bussiness Type EBS Integration Confi apis
 */
@Injectable({ providedIn: 'root' })
export class BusinessTypeEbsIntegrationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBusinessTypeEbsIntegrations()` */
  static readonly GetBusinessTypeEbsIntegrationsPath =
    '/api/v1/business-types/ebs-integrated';

  /**
   * fetch business type ebs configs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessTypeEbsIntegrations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsIntegrations$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to following fields:
       *   - businessType
       */
      search?: string;

      /**
       * weather ebs is integrated for bussiness type
       */
      isIntegrated?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetBusinessTypeEbsIntegrationResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsIntegrationService.GetBusinessTypeEbsIntegrationsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
      rb.query('isIntegrated', params.isIntegrated, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetBusinessTypeEbsIntegrationResponse>;
        })
      );
  }

  /**
   * fetch business type ebs configs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessTypeEbsIntegrations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsIntegrations(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to following fields:
       *   - businessType
       */
      search?: string;

      /**
       * weather ebs is integrated for bussiness type
       */
      isIntegrated?: boolean;
    },
    context?: HttpContext
  ): Observable<GetBusinessTypeEbsIntegrationResponse> {
    return this.getBusinessTypeEbsIntegrations$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetBusinessTypeEbsIntegrationResponse>
        ): GetBusinessTypeEbsIntegrationResponse => r.body
      )
    );
  }

  /** Path part for operation `createBusinessTypeEbsIntegration()` */
  static readonly CreateBusinessTypeEbsIntegrationPath =
    '/api/v1/business-types/ebs-integrated';

  /**
   * create business type ebs config.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBusinessTypeEbsIntegration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBusinessTypeEbsIntegration$Response(
    params: {
      body: CreateBusinessTypeEbsIntegrationRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BusinessTypeEbsIntegrationResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsIntegrationService.CreateBusinessTypeEbsIntegrationPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<BusinessTypeEbsIntegrationResponse>;
        })
      );
  }

  /**
   * create business type ebs config.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBusinessTypeEbsIntegration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBusinessTypeEbsIntegration(
    params: {
      body: CreateBusinessTypeEbsIntegrationRequest;
    },
    context?: HttpContext
  ): Observable<BusinessTypeEbsIntegrationResponse> {
    return this.createBusinessTypeEbsIntegration$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<BusinessTypeEbsIntegrationResponse>
        ): BusinessTypeEbsIntegrationResponse => r.body
      )
    );
  }

  /** Path part for operation `getBusinessTypeEbsIntegrationById()` */
  static readonly GetBusinessTypeEbsIntegrationByIdPath =
    '/api/v1/business-types/ebs-integrated/{id}';

  /**
   * fetch business type ebs configs details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessTypeEbsIntegrationById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsIntegrationById$Response(
    params: {
      /**
       * The business type ebs config id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BusinessTypeEbsIntegrationResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsIntegrationService.GetBusinessTypeEbsIntegrationByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<BusinessTypeEbsIntegrationResponse>;
        })
      );
  }

  /**
   * fetch business type ebs configs details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessTypeEbsIntegrationById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsIntegrationById(
    params: {
      /**
       * The business type ebs config id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<BusinessTypeEbsIntegrationResponse> {
    return this.getBusinessTypeEbsIntegrationById$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<BusinessTypeEbsIntegrationResponse>
        ): BusinessTypeEbsIntegrationResponse => r.body
      )
    );
  }

  /** Path part for operation `deleteBusinessTypeEbsIntegrationById()` */
  static readonly DeleteBusinessTypeEbsIntegrationByIdPath =
    '/api/v1/business-types/ebs-integrated/{id}';

  /**
   * Delete Business Type Ebs Config  by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBusinessTypeEbsIntegrationById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBusinessTypeEbsIntegrationById$Response(
    params: {
      /**
       * The Business Type Ebs Config id that needs to be delete
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsIntegrationService.DeleteBusinessTypeEbsIntegrationByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete Business Type Ebs Config  by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBusinessTypeEbsIntegrationById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBusinessTypeEbsIntegrationById(
    params: {
      /**
       * The Business Type Ebs Config id that needs to be delete
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteBusinessTypeEbsIntegrationById$Response(
      params,
      context
    ).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateBusinessTypeEbsIntegrationById()` */
  static readonly UpdateBusinessTypeEbsIntegrationByIdPath =
    '/api/v1/business-types/ebs-integrated/{id}';

  /**
   * update Business Type Ebs Config by id.
   *
   * update Business Type Ebs Config
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBusinessTypeEbsIntegrationById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBusinessTypeEbsIntegrationById$Response(
    params: {
      /**
       * The business type ebs config id that needs to be updated
       */
      id: number;
      body: UpdateBusinessTypeEbsIntegrationRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BusinessTypeEbsIntegrationResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsIntegrationService.UpdateBusinessTypeEbsIntegrationByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<BusinessTypeEbsIntegrationResponse>;
        })
      );
  }

  /**
   * update Business Type Ebs Config by id.
   *
   * update Business Type Ebs Config
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBusinessTypeEbsIntegrationById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBusinessTypeEbsIntegrationById(
    params: {
      /**
       * The business type ebs config id that needs to be updated
       */
      id: number;
      body: UpdateBusinessTypeEbsIntegrationRequest;
    },
    context?: HttpContext
  ): Observable<BusinessTypeEbsIntegrationResponse> {
    return this.updateBusinessTypeEbsIntegrationById$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<BusinessTypeEbsIntegrationResponse>
        ): BusinessTypeEbsIntegrationResponse => r.body
      )
    );
  }
}
